import { List } from "immutable";
import * as M from "../models";

export interface AdminEventState {
    events: List<M.Event.Event>;
    listEvents: List<M.Event.EventAdminListItem>;
    loadingEvent: M.Generic.ItemLoadingState;
    loadingListEvents: boolean;
    loadingSubEvents: boolean;
    subEvents: List<M.Event.SubEvent>;
    subscribedEvents: M.Generic.ResourceUpdated;
}

export const initialState: AdminEventState = {
    events: List(),
    listEvents: List(),
    loadingEvent: {},
    loadingListEvents: true,
    loadingSubEvents: true,
    subEvents: List(),
    subscribedEvents: {},
};



// WEBPACK FOOTER //
// ./src/store/AdminEventState.ts